import React from "react";
import CategoryProductList from "./CategoryProductList";

const FilterParts = () => {
  return (
    <CategoryProductList
      categoryName="Filters"
      categorySlug="filters"
    />
  );
};

export default FilterParts;
